import { gsap } from "gsap";
let cards = document.querySelector('.parallax')

if (cards) {
  gsap.timeline({
    scrollTrigger: {
      trigger: cards,
      start: "top",
      scrub: true
    }
  })
    .fromTo(".parallax", {y: "-0%"}, {
      duration: 10,
      y: "-100%",
      ease: "linear",
      overwrite: "auto"
    });
}


// // tween all .img-fluids
// gsap.utils.toArray('.parallax').forEach((img) => {
//   gsap.from(img, {
//       scrollTrigger: {
//         // markers: true,
//         trigger: img,
//         start: "top 90%"    //start on top of image at 90% viewport
//       },
//       y: 100,
//       scale: .8,
//       opacity: 0,
//       duration: .25
//     }
//   )
// })
